/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_POLICY_LIST = gql`
  query GetListOfPolicies($input: GetListOfPoliciesInput) {
    getListOfPolicies(input: $input) {
      currentPage
      data {
        premium
        policyNumber
        discountedPremium
        policyId
        purchasedAt
        discountedPremium
        countryToBeInsured
        status
        payments {
          comment
          amount
          currency
          from
        }
        coverage
        purchasedBy {
          vuid
          email
          firstName
          lastName
          address {
            addressLine1
            city
            country
          }
          occupation
          primaryContactNo
        }
        type
        productDefination
        provisionalPolicyNumber
        benificiaryDetail {
          address {
            addressLine1
            addressLine2
            city
            country
            state
          }
          email
          firstName
          lastName
          mobileNo
        }
        useOfProceeds {
          selected
          value
        }
      }
      pageSize
      totalCount
      totalPages
    }
  }
`;
